import { defineSlotRecipe } from '@chakra-ui/react';

export const jobCardSlotRecipe = defineSlotRecipe({
	base: {
		body:        {},
		description: { textStyle: 'body' },

		buttonGroup: {
			'& > *': { flex: 1 },
			'gap':   6,
			'ml':    'auto',
			'w':     'fit-content',
		},
		detail: {
			alignItems: 'center',
			gap:        4,
		},
		footer: {
			bg: 'gray.10',
			p:  4,
		},
		header: {
			gap: 2,
			p:   4,
		},
		title: {
			color:     'primary.100',
			textStyle: 'h3',
		},
	},
	slots: [
		'body',
		'buttonGroup',
		'description',
		'detail',
		'footer',
		'header',
		'root',
		'title',
	],
});
